import React from "react";
import {
  message,
  Row,
  Col,
  Button,
  Space,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import VehicleWorkingHoursAdd from "./VehicleWorkingHoursAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class VehicleWorkingHoursList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.companyStore = new CompanyStore(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleWorkingHoursStore = new VehicleWorkingHoursStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadData: 0,
      companyVal_Lab: "",
      filter: "",
      Vehicle: false,
      Driver: false,
      openVehicleHoursForm: false,
      vehicleWorkingHoursId: "",
      listDataUpdate: false,
      vehicleId: "",
      driverId: "",

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Account",
        title: context.translate("_FLEET_DASHBORD_SEARCHPOI_COMPANY_"),
        dataIndex: "name",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate('VehicleWorkingHoursList') && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },

      {
        // title: "Working Days",
        title: context.translate("_WORKING_DAYS_"),
        dataIndex: "workingDays",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          // console.log(value)
          return value.join(",");
        },
      },

      {
        // title: "Working Time From ",
        title: context.translate("_WORKING_TIME_FROM_"),
        dataIndex: "workingHourFrom",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },

      {
        // title: "Working Time To",
        title: context.translate("_WORKING_TIME_TO_"),
        dataIndex: "workingHourTo",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },

      {
        // title: "  Shift Name  ",
        title: context.translate("_SHIFT_NAME_"),
        dataIndex: "shiftName",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        ellipsis: {
          showTitle: true,
        },
        // fixed: 'right',
        align: "center",
        width: 5,
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Record"
                    title={context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete Record"
                      title={context.translate("_DELETE_RECORD_")}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                {this.props.canUpdate('VehicleWorkingHoursList') &&
                  <Tooltip title={context.translate("_EDIT_")} placement="bottom">
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>}

                {this.props.canDelete('VehicleWorkingHoursList') &&
                  <Tooltip title={context.translate("_DELETE_")} placement="bottom">

                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                }

              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidUpdate(prevProps, prevState) {
    console.log("asdf");
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setWorkingHours = this.context.viewStateStore.workingHoursObject;
      if (setWorkingHours.companyId !== "") {
        console.log(setWorkingHours);
        await this.vehicleWorkingHoursStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setWorkingHours.companyId,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setWorkingHours.companyId
        );

        await this.setState({ loadList: 1 });
        console.log("singleData", singleData);
        await this.setState({
          companyVal_Lab: singleData,
          companyId: setWorkingHours.companyId,
        });
        console.log("singleData", singleData);
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.vehicleWorkingHoursStore.getAssignAsset({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.vehicleWorkingHoursStore.getDriver(
        this.props.getUserData().userCompanyId
      );
      await this.handleSearch();
    }

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });

    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });
    // await this.setState({ companyId: comp.value });
    // const data = await this.vehicleWorkingHoursStore.getAssignAsset({
    //   companyId: comp.value,
    // });
    // console.log("data", data);
    // const driverData = await this.vehicleWorkingHoursStore.getDriver(
    //   comp.value
    // );
    // console.log(driverData);
    await this.setState({ loadData: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleWorkingHoursStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      // searchField: this.state.searchField,
      companyId: this.state.companyId,
      // filter: this.state.filter,
      // vehicleId: this.state.vehicleId,
      // driverId: this.state.driverId,
    });
    await this.setState({ loadData: 1 });
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setWorkingHoursStates({
      companyId: record.companyId,
    });
    await this.setState({ vehicleWorkingHoursId: record.workingHourId });
    await this.setState({ openVehicleHoursForm: true });
    // this.props.navigate("/vehicleworkinghoursadd/" + record.workingHourId);
  };

  async onDelete(record) {
    const response = await this.vehicleWorkingHoursStore.deleteRecord({
      workingHourId: record.workingHourId,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.data.success === "S") {
      message.success(resp.data.message);
      await this.setState({ listDataUpdate: true });
      await this.handleSearch();
      await this.setState({ openVehicleHoursForm: false });
      // this.props.navigate("/vehicleworkinghourslist");
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["fromTime"]);
      });
    } else {
      message.error(resp.data.message);
    }
  };
  closeModal = () => {
    this.setState({
      openVehicleHoursForm: false,
      vehicleWorkingHoursId: "",
    });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleWorkingHoursStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_WORKING_HOUR_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  // title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  placement="left"
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => {
                      this.setState({
                        openVehicleHoursForm: true,
                        vehicleWorkingHoursId: "",
                      });
                    }}
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  // allowClear={true}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip title={this.context.translate("_REFRESH_")} placement="bottom">

                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>


              {this.props.canCreate('VehicleWorkingHoursList') && <Button
                className="addButtonClass"
                onClick={() => {
                  this.setState({
                    openVehicleHoursForm: true,
                    vehicleWorkingHoursId: "",
                  });
                }}
              >
               

                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
               

                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>

              }
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.vehicleWorkingHoursStore?.total}
            columns={this.columns}
            dataSource={
              this.vehicleWorkingHoursStore?.vehicleWoringHoursVehicles
            }
            loading={this.vehicleWorkingHoursStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehicleHoursForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Add Working Hours"
          //   title={this.context.translate("_ADD_WORKING_HOURS_")}
          //   centered
          //   open={this.state.openVehicleHoursForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({
          //       openVehicleHoursForm: false,
          //       vehicleWorkingHoursId: "",
          //     });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleHoursForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_WORKING_HOURS_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_WORKINGHOURS_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleHoursForm: false })}
            onCancel={() =>
              this.setState({
                openVehicleHoursForm: false,
                vehicleWorkingHoursId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleWorkingHoursAdd
                vehicleWorkingHoursId={this.state.vehicleWorkingHoursId}
                response={this.responseMsg}
                companyId={this.state.companyId}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleWorkingHoursList.contextType = StoreContext;
export default observer(withRouter(VehicleWorkingHoursList));
